// extracted by mini-css-extract-plugin
export default {"DraggableCard":"bfb_a"};